import { OnboardingAddressScreen } from "@/components/screens/onboarding/Address"
import { useNavigate } from "@/router"
import { hqAddressDraftAtom } from "@/state/draft/hqAddress"
import { useAnalytics } from "@/hooks/use-analytics"
import { useAtom } from "jotai"
import { useEffect } from "react"

export default function AddressPage() {
	const analytics = useAnalytics("Create_Address")
	
	useEffect(() => {
		analytics.sendEvent("Step_StartAddress__View")
	}, [])
	const [address, setAddress] = useAtom(hqAddressDraftAtom)
	const navigate = useNavigate()
	return (
		<OnboardingAddressScreen
			onSaveState={(value) => setAddress(value)}
			onSubmit={(value) => {
				analytics.sendEvent("Step_StartAddress__Continue")
				navigate("/report/create/mileage")
			}}
			onBack={() => {
				navigate("/report/create/profession")
			}}
			value={address}
		/>
	)
}
